
import { ziperaseLogo } from './ziperase-logo';
import { mavenPro } from './maven-pro';

export default {
    /* `rows` is an array of arrays. The first element contains the column labels, and subsequent elements contain the corresponding row values. */
    async pdf({
        now,
        title,
        subtitle,
        rows,
    }) {
        // One-pixel, transparent png
        let logoData = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=";
        // if (this.companyLogo !== null) {
        //   let reader = new FileReader();
        //   reader.readAsDataURL(this.companyLogo);
        //   await new Promise(resolve => reader.onload = function () { resolve() });
        //   logoData = reader.result;
        // }

        let pdfMake = require('pdfmake/build/pdfmake.js');
        if (pdfMake.vfs === undefined) {
            pdfMake.vfs = require('pdfmake/build/vfs_fonts.js');

        }
        pdfMake.vfs["Maven-Pro.ttf"] = mavenPro;
        pdfMake.fonts = {
            Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
            },
            MavenPro: {
                normal: "Maven-Pro.ttf",
                bold: "Maven-Pro.ttf",
                italics: "Maven-Pro.ttf",
                bolditalics: "Maven-Pro.ttf",
            }
        };

        pdfMake.tableLayouts = {
            sparse: {
                hLineWidth: function (i) {
                    if (i === 1) {
                        return 0.25;
                    }
                    return 0;
                },
                vLineWidth: function () {
                    return 0;
                },
                hLineColor: function () {
                    return "#000";
                },
                paddingLeft: function (i) {
                    return i === 0 ? 0 : 4;
                },
                paddingRight: function (i, node) {
                    return (i === node.table.widths.length - 1) ? 0 : 4;
                },
                fillColor: function (rowIndex, node, columnIndex) {
                    // Skip the header row (rowIndex 0)
                    if (rowIndex === 0) return null;
                    // Start alternating from the second row
                    return (rowIndex % 2 === 0) ? null : '#f0f7fa';
                },
            }
        };

        let docDefinition = {
            pageOrientation: 'landscape',
            pageMargins: [20, 32, 20, 32],
            info: {
                title: `${title} (${subtitle})`,
                author: "Ziperase LLC",
                subject: "Customer Portal",
                creator: "Ziperase LLC",
                producer: "Customer Portal",
            },
            defaultStyle: {
                font: "Roboto",
                fontSize: 8,
            },
            styles: {
                header: {
                    font: "MavenPro",
                    fontSize: 16,
                    color: '#143B4C',
                },
            },
            images: {
                customerLogo: logoData,
                ziperaseLogo: ziperaseLogo,
            },
            header: function () {
                return {
                    table: {
                        heights: 20, // Set the height of the header bar
                        widths: ['*'],
                        body: [
                            [
                                {
                                    text: '',
                                    fillColor: '#143B4C', // Set the color of the header bar to blue
                                    margin: [0, 0, 0, 0], // Adjust margins if needed
                                    border: [false, false, false, false], // No borders
                                }
                            ]
                        ]
                    },
                    layout: 'noBorders',
                    margin: [0, 0, 0, 0], // Adjust the bottom margin to create space after the header bar

                }
            },
            content: [
                {
                    layout: 'noBorders',
                    margin: [20, 0, 20, 0],
                    table: {
                        widths: ["auto", "*", "auto"],
                        body: [
                            [
                                { image: 'customerLogo', alignment: 'left', fit: [100, 25] },
                                {
                                    // Wrap the text in a stack to control its vertical position
                                    stack: [
                                        {
                                            text: `${title} - ${subtitle}`,
                                            style: 'header',
                                            margin: [0, 5, 0, 0], // Adjust the top margin to vertically center the text with the images
                                        }
                                    ],
                                    alignment: 'center',
                                },
                                { image: 'ziperaseLogo', alignment: 'right', fit: [100, 25] },
                            ],
                        ]
                    }
                },
                {
                    margin: [0, 0, 0, 10],
                    layout: 'sparse',
                    table: {
                        widths: "auto",
                        headerRows: 1,
                        body: rows,
                    },
                },
            ],
            footer: function (currentPage, pageCount) {
                return {
                    layout: 'noBorders',
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: "*",
                        body: [
                            [
                                {
                                    text: "Report created at " + now,
                                    alignment: 'left',
                                    margin: [30, 8, 0, 12],
                                    fillColor: '#143B4C', // Blue background
                                    color: '#FFFFFF', // White text
                                },
                                {
                                    text: "Page " + currentPage.toString() + ' of ' + pageCount,
                                    alignment: 'right',
                                    margin: [0, 8, 30, 12],
                                    fillColor: '#143B4C', // Blue background
                                    color: '#FFFFFF', // White text
                                }
                            ],
                        ],
                    },
                }
            },
        };
        pdfMake.createPdf(docDefinition).download(`${title} - ${subtitle}.pdf`);
    },
}
